import { withSvgIcon } from './withSvgIcon';

export const ArrowSwap = withSvgIcon(
  <>
    <path
      d="M14 4L19 9L5 9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M10 20L5 15L19 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
